import { render, staticRenderFns } from "./Acidity.vue?vue&type=template&id=8566d96a"
import script from "./Acidity.vue?vue&type=script&lang=ts"
export * from "./Acidity.vue?vue&type=script&lang=ts"
import style0 from "../../scss/grid.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "../../scss/base.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports